import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "../../../styles.css"
import { Trans, useTranslation } from "react-i18next";

const BoatTermsModal = ({ show, handleClose, handleConfirm }) => {

  const { t } = useTranslation();
  const modalBodyRef = useRef();
  const [termsButtonDisabled, setTermsButtonDisabled] = useState(true);

  const handleScroll = () => {
    if (
      Math.abs(
        modalBodyRef.current.scrollHeight -
          modalBodyRef.current.clientHeight -
          modalBodyRef.current.scrollTop
      ) <= 1
    ) {
      setTermsButtonDisabled(false);
    } else {
      setTermsButtonDisabled(true);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("boatTerms.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body ref={modalBodyRef} onScroll={handleScroll}>
        <div>
        <p><Trans i18nKey="boatTerms.intro" components={{ strong: <strong /> }} /></p>
    <ol>
      {Object.keys(t("boatTerms.items", { returnObjects: true })).map((key) => (
        <li key={key}>
          <Trans i18nKey={`boatTerms.items.${key}`} />
        </li>
      ))}
    </ol>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose}>
        {t("boatTerms.close")}
        </Button>
        <Button
          variant="success"
          onClick={handleConfirm}
          disabled={termsButtonDisabled}
        >
          {t("boatTerms.confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BoatTermsModal;
